import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DesktopMenu from "../../../common/DesktopMenu/index";
import MobileMenu from "../../../common/MobileMenu/index";
import useWindowSize from "../../../common/windowSize";
import NewFooter from "../../../common/NewFooter";
import BackButton from "../../Products/BackButton";
import Paper from "@mui/material/Paper";
import { useTranslation } from "react-i18next";
import { Background } from "../../../common/Faq/styles";
import { SettingsHeader, Title } from "../styles";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import twint from "../../../assets/twint.webp";
import { privateAPI } from "../../../utils/api";
import { toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const PaymentOptions = () => {
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const paperStyle = {
    display: "flex",
    width: "90%",
    margin: "12.5px auto",
    maxWidth: "450px",
    alignItems: "center",
    justifyContent: "center",
    padding: "25px",
    cursor: "pointer",
  };

  const checkout = async () => {
    setLoading(true);
    try {
      await privateAPI.post(`/auth/bacchus/client/cart/order`, {
          paymentMethod: "delivery"
        });

      setLoading(false);
      navigate("/payment-shipment")
    } catch (error) {
      setLoading(false);
      console.log(error);
      if (error.request.status === 500)
        return toast.error("Internal server error");
    }
  }

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? (
        <MobileMenu single={true} />
      ) : (
        <DesktopMenu single={true} />
      )}
      <Background marginTop adminPanel>
        <SettingsHeader style={{ marginBottom: "25px" }}>
          <BackButton userPanel />
          <Title>{t("paymentOptions")}</Title>
        </SettingsHeader>
        <Paper elevation={3} style={paperStyle} onClick={() => navigate("/payment-card")}>
          <strong style={{ color: "#1b2c58", marginRight: "5px" }}>
            Pay with card
          </strong>
          <CreditCardIcon />
        </Paper>
        {/* <Paper elevation={3} style={paperStyle} onClick={() => navigate("/payment-twint")}> */}
        <Paper elevation={3} style={paperStyle} onClick={() => toast.success("Coming soon!")}>
          <strong style={{ color: "#1b2c58", marginRight: "5px" }}>
            Pay with Twint
          </strong>
          <img
            src={twint}
            alt="twint"
            style={{ height: "25px", width: "25px" }}
          />
        </Paper>
        <Paper elevation={3} style={paperStyle} onClick={checkout}>
          <strong style={{ color: "#1b2c58", marginRight: "5px" }}>
            Pay when arrive
          </strong>
          <LocalShippingIcon />
        </Paper>
      </Background>
      <NewFooter />
      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </React.Fragment>
  );
};

export default PaymentOptions;
